import { render, staticRenderFns } from "./drop-zone-item.vue?vue&type=template&id=3ab61a56&scoped=true&"
import script from "./drop-zone-item.vue?vue&type=script&lang=js&"
export * from "./drop-zone-item.vue?vue&type=script&lang=js&"
import style0 from "./drop-zone-item.vue?vue&type=style&index=0&id=3ab61a56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab61a56",
  null
  
)

export default component.exports